// extracted by mini-css-extract-plugin
module.exports = {"topBar":"DetailsHeader_topBar__hTKL7"};